import { useState, useEffect } from "react"
import LoginRevamp from "../../features/auth/LoginRevamp"
import FreeTrialForm from "../../features/freetrial/FreeTrialForm"
import SupportRequestForm from "../../features/support/SupportRequestForm"

const Header = () => {
    const [navbarToggle, setNavbarToggle] = useState(false)
    const [scrollPosition, setScrollPosition] = useState(0)

    const [isLoginModalOpen, setLoginModalOpen] = useState(false)
    const [isFreeTrialModalOpen, setFreeTrialModalOpen] = useState(false)
    const [isSupportModalOpen, setSupportModalOpen] = useState(false)

    const handleScroll = () => {
        const position = window.scrollY;
        console.log(position)
        setScrollPosition(position);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleNavbarToggle = () => {
        setNavbarToggle(!navbarToggle)
    }

    return (
        <header className={"dash-header" + (scrollPosition > 100 ? " active" : "")} data-header>
            <div className="container">
                <a href="#" className="logo" role="logo">
                    <div className="logo-light">Advisors Reserve</div>
                    <div className="logo-dark">Advisors Reserve</div>
                </a>

                <nav className={"navbar" + (navbarToggle ? " active" : "")}>
                    <div className="navbar-top">
                        <a href="#" className="logo" role="logo">
                            <div className="navbar-top-logo">Advisors Reserve</div>
                        </a>

                        <button className="nav-close-btn" aria-label="close menu" onClick={() => handleNavbarToggle()}>
                            <ion-icon name="close-outline" aria-hidden="true"></ion-icon>
                        </button>
                    </div>

                    <ul className="navbar-list">
                        <li>
                            <a href="#features" className="navbar-link" role="link">Features</a>
                        </li>
                        <li>
                            <a className="navbar-link" role="link" onClick={() => setFreeTrialModalOpen(true)}>Free Trial</a>
                        </li>
                        <li>
                            <a className="navbar-link" role="link" onClick={() => setSupportModalOpen(true)}>Support</a>
                        </li>
                        <li>
                            <a href="#footer" className="navbar-link" role="link">Resources</a>
                        </li>
                    </ul>
                </nav>

            <div className="btn btn-primary" onClick={() => setLoginModalOpen(true)}>Login</div>

            <button className="nav-open-btn" aria-label="open menu" onClick={() => handleNavbarToggle()}>
                <ion-icon name="menu-outline" aria-hidden="true"></ion-icon>
            </button>

            <div className={"overlay" + (navbarToggle ? " active" : "")} data-nav-toggler data-overlay onClick={() => handleNavbarToggle()}></div>
        </div>

        <LoginRevamp isModalOpen={isLoginModalOpen} onClose={() => setLoginModalOpen(false)} />
        {isFreeTrialModalOpen && <FreeTrialForm isModalOpen={isFreeTrialModalOpen} onClose={() => setFreeTrialModalOpen(false)} />}
        {isSupportModalOpen && <SupportRequestForm isModalOpen={isSupportModalOpen} onClose={() => setSupportModalOpen(false)} />}


      </header>
    )
}

export default Header